import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';

import NotFound from 'Core/Status/NotFound';
import PageController from 'Site/Controllers/PageController';
import PostController from 'Site/Controllers/PostController';

class SiteRoutes extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { pages, blogs } = this.props;
    return (
      <Switch>
        {pages.map(({ url, name, content }) => {
          const props = {
            key: url,
            path: '/' + url,
            exact: true,
            component: ({ location }) => {
              const props = { name, location, content };
              return <PageController {...props} />
            }
          };
          return <Route {...props} />
        })}
        {blogs.map(({ id }) => {
          const props = {
            key: id,
            exact: true,
            path: `/${id}/:slug`,
            component: ({ match }) => {
              const { slug } = match.params;
              return <PostController blogId={id} postId={slug} />
            }
          };
          return <Route {...props} />
        })}
        <Route component={NotFound} />
      </Switch>
    );
  }
};

export default SiteRoutes;



// WEBPACK FOOTER //
// ./client/Site/Routes.jsx